<template>
    <div class="project-card" v-if="type == 'projectCard'">
        <a v-if="redirectLink" :href="redirectLink">
            <b-card style="border:none;border-radius: 16px;" class="mb-2 text-left">
                <div class="px-md-4 px-3 pt-3">
                    <div class="d-flex pb-3">
                        <div :style="'background: #' + skillColor" style="border-radius: 50%;padding: 15px;position: relative;z-index:1;">
                            <!-- <img :src="skillImage" alt=""> -->
                            <img rel="preload" :src="skillImage" alt="">
                        </div>
                        <p class="my-auto text-white px-3 py-1 pl-4"  :style="'background: #' + skillColor" style="position: relative;left: -20px;font-size: 18px;border-radius: 20px;">{{skillName}}</p>
                    </div>
                    <h4> {{name}} , {{age}}</h4>
                    <p style="min-height: 70px;">{{description}}</p>
                </div>
                <div class="d-flex">
                    <!-- <img class="" style="max-width: 100%;height: fit-content;width: 100%;" :src="projectImage" alt=""> -->
                    <img rel="preload" class="prjcard-img" v-bind="mainProps" v-if="projectImage" :src="projectImage" alt="" style="width: 100%;" />
                </div>
            </b-card>
        </a>
        <router-link v-else :to="`/products/${this.productUri}`">
            <b-card style="border:none;border-radius: 16px;" class="mb-2 text-left">
                <div class="px-md-4 px-3 pt-3">
                    <div class="d-flex pb-3">
                        <div :style="'background: #' + skillColor" style="border-radius: 50%;padding: 15px;position: relative;z-index:1;">
                            <!-- <img :src="skillImage" alt=""> -->
                            <img rel="preload" :src="skillImage" alt="">
                        </div>
                        <p class="my-auto text-white px-3 py-1 pl-4"  :style="'background: #' + skillColor" style="position: relative;left: -20px;font-size: 18px;border-radius: 20px;">{{skillName}}</p>
                    </div>
                    <h4> {{name}} , {{age}}</h4>
                    <p style="min-height: 70px;">{{description}}</p>
                </div>
                <div class="d-flex">
                    <!-- <img class="" style="max-width: 100%;height: fit-content;width: 100%;" :src="projectImage" alt=""> -->
                    <img rel="preload" class="prjcard-img" v-bind="mainProps" v-if="projectImage" :src="projectImage" alt="" style="width: 100%;" />
                </div>
            </b-card>
        </router-link>
    </div>
    <div v-else-if="type == 'topFeature'">
        <b-card style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <div style="height:35vh;overflow:hidden">
                <!-- <img :src="projectImage" alt="" width="100%" style=""> -->
                <b-img-lazy v-bind="mainProps" v-if="projectImage" :src="projectImage" alt="" style="max-width: 100%;height: auto;"></b-img-lazy>
            </div>
            <div class="px-3 pt-2">
                <p class="m-0" style="font-size: 16px;font-weight: 500;">{{name}}</p>
                <p style="font-size: 12px;color: rgba(48, 48, 48, 0.7);">{{description}}</p>
            </div>
        </b-card>
    </div>
    <div v-else-if="type == 'learnCard'">
        <b-card style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <div style="height:35vh;overflow:hidden">
                <!-- <img :src="projectImage" alt="" style="width: -webkit-fill-available;height: auto;"> -->
                <b-img-lazy v-bind="mainProps" v-if="projectImage" :src="projectImage" alt="" style="width: -webkit-fill-available;height: auto;"></b-img-lazy>
            </div>
            <div class="px-3 pt-2">
                <p class="m-0" style="font-size: 16px;font-weight: 500;">{{name}}</p>
                <p style="font-size: 12px;color: rgba(48, 48, 48, 0.7);">{{description}}</p>
                <div v-if="skillName" class="d-flex pb-2 flex-wrap">
                    <span :key="productkey" v-for="(skill,productkey) in skillName" class="my-1">
                        <a href="" v-if="skill"  class="sub-category text-white mx-1 my-1" style="background: #E79619;">{{skill}}</a>
                    </span>
                    <!-- <p class="my-auto mx-2">+3</p> -->
                </div>
            </div>
        </b-card>
    </div>
    <div v-else-if="type == 'courseFun'">
        <div style="border: 1px solid #E7E7E7; border-radius: 8px; position: relative;" class="mb-2 text-left">
            <div
                style="
                position: absolute;
                background: #FAAB31;
                top: 12px;
                left: -12px;
                border-radius: 8px;
                wodth: 64px;
                height: 64px;"
            >
                <img
                    :src="projectImage"
                    :alt="`Icon image mentioning the skill ${description} acquired from the course`"
                    width="64"
                    height="64"
                    style="border-radius: 8px;"
                />
            </div>
            <div class="pl-md-2 pl-4 pr-0 py-4 col-md-7 col-9 mx-auto">
                <p class="m-0 text-white" style="font-size: 16px;font-weight: 500;">{{description}}</p>
                <p class="text-white m-0" style="font-size: 12px;color: rgba(48, 48, 48, 0.7);">{{name}}</p>
            </div>
        </div>
    </div>
    <div v-else-if="type == 'avishkaarKids'">
        <b-card style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <div style="height:35vh;overflow:hidden">
                <img src="https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png" alt="" width="100%" style="max-width: 100%;height: auto;">
            </div>
            <div style="width: 104.33px;height: 104.75px;position: absolute;right: -2%;margin-top: -26%;">
                <img src="https://images.avishkaar.cc/images/workflow/hp_v1/user.jpg" alt="" width="100%" style="border-radius: 50%;">
            </div>
        </b-card>
    </div>
    <div v-else-if="type == 'mediaPresense'" class="mediaPresense">
        <b-modal id="videoModal" ref="videoModal" hide-footer hide-header>
            <button type="button" class="hp_modal_btn" @click="closeYtModal"><i class="fas fa-times"></i></button>
            <div class="d-block text-center px-3 pt-3 pb-2">
                <iframe width="100%" height="315" :src="'https://www.youtube.com/embed/' + ytSource" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </b-modal>
        <b-card v-if="category == 'digital_media'" style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <a :href="url">
                <p style="position: absolute;color: white;left: 20px;top: 10px;font-weight: bold;">{{title}}</p>
                <div class="assest-sec" style="height:30vh;overflow:hidden;background-repeat: no-repeat;background-size: cover;" :style="'background-image:url(' + thumbnail + ');'">
                </div>
                <div class="px-1 pt-2">
                    <p style="font-size: 15px;color: rgba(48, 48, 48, 0.8);">{{text.substring(-6, 30)}} <span style="color:#F36F2E;cursor: pointer;">read more</span></p>
                </div>
            </a>
        </b-card>
        <b-card v-if="category == 'print_media'" style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <a :href="url">
                <p style="position: absolute;color: white;left: 20px;top: 10px;font-weight: bold;">{{title}}</p>
                <div class="assest-sec" style="height:30vh;overflow:hidden;background-repeat: no-repeat;background-size: cover;" :style="'background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgb(0, 0, 0,0.6)), url(' + thumbnail + ');'">
                </div>
                <div class="px-1 pt-2">
                    <p style="font-size: 15px;color: rgba(48, 48, 48, 0.8);">{{text.substring(-6, 30)}} <span style="color:#F36F2E;cursor: pointer;" v-if="url">read more</span></p>
                </div>
            </a>
        </b-card>
        <b-card v-if="category == 'video'" style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <div @click="openYtModal(media)" class="1">
                <p style="position: absolute;color: white;left: 20px;top: 10px;font-weight: bold;">{{title}}</p>
                <div class="assest-sec" style="height:30vh;overflow:hidden;background-repeat: no-repeat;background-size: cover;" :style="'background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgb(0, 0, 0,0.6)), url(' + thumbnail + ');'">
                </div>
                <div class="px-1 pt-2">
                    <p style="font-size: 15px;color: rgba(48, 48, 48, 0.8);">{{text.substring(-6, 40)}} <span style="color:#F36F2E;cursor: pointer;" v-if="url">read more</span></p>
                </div>
            </div>
        </b-card>
    </div>
    <div v-else-if="type == 'startStudent'" class="startStudent">
        <b-card style="border:none;border-radius: 16px;" class="mb-2 text-left">
            <div class="">
                <div class="d-flex flex-wrap">
                    <div style="position: absolute;left: -9px;top: 25px;z-index: 11;">
                        <svg width="66" height="130" viewBox="0 0 66 130" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.08398 8.80176L9.26772 0.769432V21.4844H1.08398V8.80176Z" fill="#F4F4F4"/>
                        <path d="M1.08398 121.255L9.26772 129.287V108.572H1.08398V121.255Z" fill="#D3D3D3"/>
                        <path d="M0.712158 121.253L65.4381 76.018V52.3438L0.712158 94.6191V121.253Z" fill="#EEEEEE"/>
                        <path d="M65.4384 51.9208L0.712402 9.22266V34.5879L65.4384 76.0178V51.9208Z" fill="white"/>
                        <path d="M18.9979 32.6084C19.2564 32.8536 19.3965 33.1543 19.4182 33.5104C19.4398 33.8666 19.3409 34.1948 19.1214 34.4952C18.9231 34.7664 18.6773 34.9607 18.3839 35.0779C18.0991 35.1935 17.7831 35.2249 17.436 35.172C17.0889 35.1191 16.7363 34.9772 16.3783 34.7462L14.102 33.2775L17.8087 28.2057L19.9867 29.6109C20.3447 29.8419 20.6115 30.096 20.7872 30.3733C20.968 30.6539 21.0513 30.9358 21.0372 31.219C21.0282 31.5054 20.9316 31.7746 20.7475 32.0265C20.5316 32.322 20.2678 32.5153 19.9563 32.6066C19.6498 32.7011 19.3304 32.7017 18.9979 32.6084ZM17.3381 30.9815L18.3061 31.606C18.5581 31.7687 18.7912 31.8406 19.0052 31.8219C19.2228 31.7983 19.4059 31.6848 19.5546 31.4813C19.7033 31.2779 19.7503 31.0765 19.6956 30.8773C19.6409 30.678 19.4875 30.4971 19.2354 30.3344L18.2674 29.7099L17.3381 30.9815ZM16.8325 33.8203C17.0896 33.9862 17.3312 34.0565 17.5574 34.0314C17.7886 34.0094 17.982 33.8919 18.1378 33.6788C18.2971 33.4608 18.3454 33.2424 18.2827 33.0237C18.2235 32.8002 18.0653 32.6055 17.8082 32.4396L16.7645 31.7662L15.7662 33.1323L16.8325 33.8203ZM23.1382 32.8526L22.2089 34.1242L23.9861 35.2708L23.3966 36.0774L21.6195 34.9307L20.637 36.275L22.6411 37.568L22.0357 38.3964L18.9729 36.4202L22.6849 31.3411L25.7477 33.3172L25.1423 34.1456L23.1382 32.8526ZM24.7946 40.2513C24.4265 40.0138 24.138 39.7386 23.9291 39.4256C23.7252 39.1158 23.6207 38.7918 23.6157 38.4535C23.6107 38.1152 23.7189 37.7894 23.9405 37.4761L25.0748 38.208C24.9377 38.4261 24.893 38.6396 24.9406 38.8485C24.9933 39.0607 25.1406 39.2449 25.3826 39.401C25.6296 39.5604 25.8645 39.63 26.0871 39.6096C26.3132 39.5844 26.4935 39.4798 26.6281 39.2957C26.7378 39.1456 26.7802 38.9911 26.7552 38.8324C26.7302 38.6737 26.6641 38.5206 26.5568 38.373C26.4581 38.2238 26.3075 38.0339 26.105 37.8035C25.833 37.4854 25.6222 37.2104 25.4727 36.9785C25.3317 36.745 25.2522 36.4833 25.2339 36.1936C25.2243 35.9022 25.3363 35.5967 25.57 35.2769C25.7895 34.9766 26.0588 34.7654 26.3779 34.6434C26.6971 34.5215 27.0403 34.4934 27.4076 34.5593C27.7784 34.6204 28.1454 34.768 28.5084 35.0022C29.0529 35.3535 29.4002 35.7665 29.5504 36.2412C29.7091 36.7143 29.6397 37.1899 29.3422 37.6681L28.1776 36.9166C28.295 36.7357 28.3212 36.5424 28.2565 36.3367C28.2003 36.1293 28.0537 35.9492 27.8167 35.7963C27.61 35.6629 27.4065 35.6065 27.2061 35.6269C27.0107 35.6505 26.8423 35.7592 26.7006 35.953C26.6015 36.0886 26.5637 36.2318 26.5872 36.3823C26.6192 36.5313 26.6821 36.6788 26.7757 36.8248C26.878 36.9692 27.0286 37.159 27.2275 37.3943C27.4996 37.7124 27.7086 37.9898 27.8546 38.2266C28.0006 38.4633 28.0809 38.729 28.0956 39.0236C28.1102 39.3182 28.0025 39.623 27.7724 39.9378C27.5742 40.2091 27.317 40.4138 27.0008 40.552C26.6847 40.6902 26.3341 40.7385 25.9491 40.6968C25.5676 40.6503 25.1828 40.5018 24.7946 40.2513ZM34.9278 39.251L34.3277 40.0721L32.9211 39.1645L29.8145 43.4153L28.7558 42.7322L31.8624 38.4814L30.4557 37.5739L31.0558 36.7528L34.9278 39.251ZM38.5838 41.6099L34.8771 46.6817L33.8183 45.9986L37.525 40.9267L38.5838 41.6099ZM40.4493 50.277L39.3905 49.5939L39.5369 44.5665L36.9932 48.0471L35.9345 47.364L39.6465 42.2848L40.7052 42.9679L40.5535 48.0025L43.1025 44.5147L44.1613 45.1978L40.4493 50.277Z" fill="black"/>
                        <path d="M4.48065 104.452C4.1028 103.963 3.8793 103.448 3.81015 102.908C3.7423 102.36 3.82409 101.844 4.05554 101.36C4.28828 100.867 4.65248 100.452 5.14814 100.114C5.72806 99.7185 6.34617 99.5144 7.00247 99.5017C7.65876 99.4891 8.26808 99.6752 8.83042 100.06L7.6334 100.877C7.33101 100.72 7.02492 100.657 6.71511 100.687C6.41027 100.714 6.11658 100.824 5.83405 101.017C5.5317 101.223 5.31475 101.476 5.18322 101.776C5.05298 102.068 5.01632 102.383 5.07326 102.721C5.13515 103.056 5.29449 103.389 5.55128 103.722C5.80441 104.049 6.09262 104.295 6.41593 104.459C6.74052 104.614 7.07249 104.681 7.41183 104.66C7.75247 104.631 8.07397 104.513 8.37632 104.307C8.65885 104.114 8.86082 103.886 8.98225 103.622C9.10496 103.349 9.13408 103.054 9.06961 102.735L10.2666 101.919C10.4857 102.545 10.4872 103.15 10.2711 103.732C10.0563 104.306 9.65648 104.793 9.0716 105.192C8.57594 105.53 8.04482 105.729 7.47825 105.789C6.91297 105.842 6.36527 105.755 5.83516 105.529C5.31001 105.3 4.85851 104.941 4.48065 104.452ZM14.8277 99.7538L12.7608 101.164L13.1507 102.344L12.0577 103.09L10.0775 96.8386L11.2894 96.0119L17.002 99.7171L15.9016 100.468L14.8277 99.7538ZM13.9289 99.1489L11.5712 97.5815L12.427 100.173L13.9289 99.1489ZM17.4014 91.8536L18.0232 92.6584L16.6403 93.6017L19.8594 97.7679L18.8185 98.478L15.5994 94.3117L14.2165 95.255L13.5947 94.4503L17.4014 91.8536ZM19.8347 91.4227L20.7977 92.669L22.5449 91.4771L23.1557 92.2676L21.4085 93.4595L22.4265 94.777L24.3967 93.433L25.0241 94.2449L22.0129 96.2989L18.1665 91.3208L21.1776 89.2668L21.8049 90.0787L19.8347 91.4227ZM26.9092 87.6518C26.6288 87.524 26.3423 87.4766 26.0498 87.5094C25.7572 87.5422 25.4722 87.6532 25.1946 87.8426C24.8873 88.0522 24.666 88.3046 24.5308 88.5999C24.3956 88.8951 24.3565 89.2118 24.4134 89.55C24.4704 89.8882 24.6235 90.2187 24.873 90.5415C25.1298 90.8739 25.4205 91.1179 25.7451 91.2735C26.0746 91.4257 26.4122 91.4854 26.7578 91.4527C27.1034 91.42 27.4373 91.2937 27.7595 91.0739C28.156 90.8034 28.4036 90.4823 28.5023 90.1104C28.5974 89.7338 28.5451 89.3381 28.3456 88.9231L26.5612 90.1403L25.9725 89.3783L28.7829 87.4612L29.4542 88.3301C29.6526 88.724 29.7515 89.1459 29.751 89.5958C29.7504 90.0457 29.6389 90.4843 29.4165 90.9115C29.1953 91.3306 28.8617 91.6923 28.4156 91.9966C27.915 92.3381 27.3789 92.5407 26.8074 92.6043C26.2372 92.6597 25.687 92.5746 25.1569 92.349C24.6317 92.1199 24.1802 91.7609 23.8024 91.2719C23.4245 90.7828 23.201 90.2683 23.1319 89.7282C23.064 89.1799 23.1483 88.662 23.3847 88.1745C23.6224 87.6789 23.9891 87.262 24.4847 86.9239C25.0696 86.5249 25.6841 86.316 26.3281 86.2973C26.9684 86.2737 27.5611 86.4531 28.1062 86.8353L26.9092 87.6518ZM34.1466 88.0982C33.6609 88.4295 33.1304 88.6246 32.5552 88.6835C31.98 88.7423 31.4249 88.6606 30.8898 88.4383C30.3511 88.2113 29.8928 87.8533 29.5149 87.3642C29.1407 86.88 28.924 86.3644 28.8648 85.8175C28.8019 85.2659 28.8893 84.7423 29.127 84.2466C29.3647 83.751 29.7264 83.3375 30.2121 83.0061C30.7029 82.6714 31.2333 82.4763 31.8036 82.4208C32.3788 82.362 32.9332 82.4478 33.467 82.6782C34.0021 82.9005 34.4567 83.2537 34.8309 83.738C35.2088 84.227 35.4291 84.7474 35.492 85.299C35.5562 85.8425 35.4695 86.362 35.2318 86.8577C34.9941 87.3533 34.6324 87.7668 34.1466 88.0982ZM33.4588 87.208C33.771 86.995 33.9948 86.7408 34.13 86.4456C34.2615 86.1456 34.297 85.8242 34.2364 85.4812C34.1758 85.1383 34.0171 84.8007 33.7603 84.4683C33.5035 84.136 33.2128 83.892 32.8882 83.7364C32.5599 83.5761 32.2255 83.5106 31.8848 83.5399C31.5442 83.5693 31.2178 83.6905 30.9055 83.9035C30.5932 84.1165 30.367 84.3723 30.2269 84.6709C30.0917 84.9661 30.0544 85.2852 30.115 85.6281C30.1719 85.9663 30.3288 86.3016 30.5856 86.6339C30.8423 86.9663 31.1349 87.2126 31.4631 87.373C31.7914 87.5333 32.1277 87.6012 32.472 87.5766C32.8176 87.5438 33.1465 87.421 33.4588 87.208ZM40.2245 83.8761L37.5828 82.72L37.0921 83.0547L38.5888 84.9919L37.5479 85.7019L33.707 80.7309L35.655 79.4021C36.0564 79.1283 36.4516 78.9638 36.8406 78.9088C37.2258 78.849 37.5777 78.8881 37.8962 79.0261C38.2161 79.1559 38.486 79.3633 38.7061 79.6481C38.9593 79.9757 39.0894 80.3401 39.0966 80.7412C39.1001 81.1376 38.9446 81.5192 38.63 81.886L41.429 83.0545L40.2245 83.8761ZM36.5143 82.307L37.3842 81.7136C37.6667 81.5209 37.8278 81.3131 37.8676 81.0902C37.9036 80.8626 37.8318 80.6325 37.652 80.3998C37.4759 80.1719 37.2708 80.0436 37.0366 80.0148C36.7988 79.9813 36.5386 80.0609 36.2561 80.2536L35.3862 80.847L36.5143 82.307ZM42.6075 74.6595L43.3567 79.0968L44.6938 80.8274L43.6529 81.5374L42.3158 79.8069L38.0499 77.7684L39.2247 76.9671L42.0953 78.4782L41.4477 75.4507L42.6075 74.6595Z" fill="black"/>
                        </svg>
                    </div>
                    <div class="col-12 p-0 overflow-hidden" style="position: relative;z-index:1;height:30vh">
                        <b-img-lazy v-if="projectImage" v-bind="mainProps" style="width:100%" :src="projectImage" alt="Image 1"></b-img-lazy>
                    </div>
                </div>
                <div class="d-flex flex-wrap px-3">
                    <div class="col-5 px-0 my-auto" style="color: #303030;font-weight: 500;">
                        Simple car
                    </div>
                    <div class="col-5 pl-0 text-right " style="color: #FCAC31;">
                        <strong>Maker of the Month</strong>
                    </div>
                    <div class="col-2 px-0">
                        <svg width="36" height="57" viewBox="0 0 36 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.757568 0.0566406V56.4L18.3809 39.2768L35.9556 56.4V0.0566406H0.757568Z" fill="#FBAE40"/>
                        </svg>
                    </div>
                    <div class="col-12 d-flex pb-2 px-0">
                        <b-img-lazy v-if="user_image" v-bind="mainProps" style="height: 40px; width: 40px; border-radius: 50%;" :src="user_image" alt="Image 1"></b-img-lazy>
                        <p class="m-0 pl-2 my-auto">By <strong>{{user_name}}</strong></p>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
export default {
    name: "CarouselCard",
    props: ["type","name","age","description","skillName","projectImage","skillColor","skillImage","productUri","user_name","user_image","category","thumbnail","url","text","media","title", "redirectLink"],
    data() {
    return {
        mainProps: {
            center: false,
            fluidGrow: false,
            blank: true,
            blankColor: '#bbb'
        },
        ytSource: null
        }
    },
    methods: {
        openYtModal(src) {
        this.$refs['videoModal'].show()
        this.ytSource = src
        },
        closeYtModal() {
        this.$refs['videoModal'].hide()
        this.ytSource = null
        },
    },
};
</script>
<style  scoped>
/* project card */
@media screen and (min-width: 577px) and (max-width: 1024px) {
    .project-card {
        width: 330px;
        margin-top: 30px;
    }
}
@media screen and (max-width: 576px) and (min-width: 321px) {
    .project-card {
        width: 280px;
        padding: 0;
    }
}
@media screen and (max-width: 320px) {
    .project-card {
        width: 250px;
    }
}


.card-body {
    padding: 0px;
    background: #FFFFFF;
    border-radius: 16px;
}
.mediaPresense .card-body {
    box-shadow: none !important;
}
.slick-current .card-body{
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.035), 0px -1px 37px rgba(0, 0, 0, 0.07), 0px 0.38599px 1.0172px rgba(0, 0, 0, 0.035) ;
    opacity: 1 !important;
    overflow: hidden;
}
.slick-active .card-body {
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.035), 0px -1px 37px rgba(0, 0, 0, 0.07), 0px 0.38599px 1.0172px rgba(0, 0, 0, 0.035) ;
    opacity: 0.7;
    overflow: hidden;
}
.startStudent .card-body  {
    opacity: 1 !important;
}
.sub-category {
    border-radius: 24px;
    padding: 4px 16px;
    font-family: Roboto;
    font-size: 14px;
}
.assest-sec {
    border: 2px solid rgba(255, 255, 255, 0.8);
    border-radius: 10px;
}
.hp_modal_btn {
      border: none;
    position: absolute;
    z-index: 2;
    background: #d2691e;
    padding: 0;
    top: -15px;
    right: -15px;
    border-radius: 50%;
    height: 30px;
    width: 30px;
}

.prjcard-img {
    width: 100%;
    height: 100%;
}
</style>

<style>
@media screen and (min-width: 1025px) {
    .innovate-carousel .project-card {
        /* width: 330px; */
        padding-left: 5px;
        margin-top: 30px;
        margin: 30px 20px auto 20px;
    }
}
</style>